import { debug } from './debug';
import { list } from './list';
import { add } from './add';

// Export all commands
export const commands = [debug, list, add];
